var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blockchain"},[_c('Header'),_c('FirmwareUpgrade')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }